// Taken from https://github.com/tappleby/redux-batched-subscribe/issues/24
import enhancer from './enhancer';
import middleware from './middleware';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const batchAction = (action: any) => ({ ...action, meta: { ...(action.meta || {}), batch: true } });

export { batchAction, enhancer, middleware };
